import React from 'react';
import strings from '../../lang/lang';
import { ReactComponent as CheckThank } from '../../styles/icon/check-thank.svg';

const ContactFormSucceededView = () => {
  return (
    <div className="contact__thank">
      <CheckThank />
      <h2>{strings.contact.text.titleH2Thank}</h2>
      <p>{strings.contact.text.descriptionThank}</p>
    </div>
  );
};

export default ContactFormSucceededView;
